<template>
  <div
    class="promo-card shadow"
    :class="{ 'promo-card-clickable': item.link }"
    @click="handleCardClick"
  >
    <div v-if="item.image_url" class="promo-card-image">
      <img class="img-fluid" :src="item.image_url" :alt="item.name" />
    </div>
    <div class="promo-card-content">
      <h4 class="promo-card-title">{{ item.name }}</h4>
      <p class="promo-card-description">
        {{ item.description }}
      </p>
      <div class="mt-auto">
        <b-button
          variant="white"
          size="lg"
          style="margin-left: -15px; pointer-events: none;"
        >
          {{ item.button_text || 'Learn More' }}
          <i class="fa-regular ml-2 fa-chevron-right"></i>
        </b-button>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "PromotionalCard",
  props: {
    item: {
      type: Object,
      required: true
    },
    index: {
      type: Number,
      default: 0
    }
  },
  methods: {
    handleCardClick() {
      this.$emit("card-click", this.item);
    }
  }
};
</script>

<style scoped>
.promo-card {
  background-color: white;
  border-radius: 8px;
  display: flex;
  flex-direction: column;
  position: relative;
  overflow: hidden;
  height: 100%;
  min-height: 475px;
  transition: transform 0.3s ease, box-shadow 0.3s ease;
}

.promo-card-clickable {
  cursor: pointer;
}

.promo-card:hover {
  transform: translateY(-4px);
}

.promo-card-image {
  overflow: hidden;
  background: #f5f5f5;
}

.promo-card-image .img-fluid {
  width: 100%;
  height: 246px;
  object-fit: cover;
  object-position: center;
}

.promo-card-content {
  flex-grow: 1;
  display: flex;
  flex-direction: column;
  padding: 18px;
}

.promo-card-title {
  font-size: 18px;
  font-weight: bold;
  margin-bottom: 15px;
  color: #1a1a1a;
}

.promo-card-description {
  font-size: 1.4rem;
  margin-bottom: 20px;
  flex-grow: 1;
}
</style>
